import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Cooperate from "@/views/Cooperate";
import Brand from "@/views/Brand";
import MsTrader from "@/views/MsTrader";
import About from "@/views/About";
import ContactWe from "@/views/ContactWe";
import MsStrategy from "@/views/MsStrategy";
import News from "@/views/News";
import NewsDt from "@/views/NewsDt";
import PrePage from "@/views/PrePage";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: PrePage,
  },
  {
    path: '/index',
    component: Home,
    children: [
      { path: '/head', component: () => import('../views/Head.vue') },
      { path: '/foot', component: () => import('../views/Foot.vue') }
    ]
  },
  {
    path: '/cooperate',
    component: Cooperate
  },
  {
    path: '/brand',
    component: Brand
  },
  {
    path: '/msTrader',
    component: MsTrader
  },
  {
    path: '/about',
    component: About
  },
  {
    path: '/contactWe',
    component: ContactWe
  },
  {
    path: '/msStrategy',
    component: MsStrategy
  },
  {
    path: '/news',
    component: News
  },
  {
    path: '/newsDt',
    component: NewsDt
  }
]

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

router.beforeEach((to, from, next) => {
  //路由加载之前，进行设备判断
  if (typeof window !== 'undefined' && typeof window.navigator !== 'undefined') {
    if (!/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      //电脑端访问，则直接放行
      if (to.path == '/') next({path: '/index'})
      next()
    } else {
      //移动端跳转
      location.href = 'https://wx9eb264cd8c475cfd.wx.gcihotel.net/wechat/?/=#/book';
    }
  }
})

export default router
